import type { QueryFunctionContext } from '@tanstack/react-query';
import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '../../../lib/api';
import type { PageCompanyBranchRelationDTO } from './types';
import type { AdsLibraryApiPathParams } from './parseAdsLibraryApiPath';
import { parseAdsLibraryApiPath } from './parseAdsLibraryApiPath';

const getPageCompanyBranchRelations = async ({
  signal,
  queryKey,
}: QueryFunctionContext<[string, string]>): Promise<PageCompanyBranchRelationDTO[]> => {
  const res = await apiClient.get<{ data: PageCompanyBranchRelationDTO[] }>(queryKey[1], {
    signal,
  });

  return res.data.data;
};

export const getPageCompanyBranchRelationsOptions = (params: AdsLibraryApiPathParams = {}) =>
  queryOptions({
    staleTime: 60 * 60 * 1000,
    queryFn: getPageCompanyBranchRelations,
    queryKey: [
      'getPageCompanyBranchRelations',
      parseAdsLibraryApiPath('ad_page_company_branch_relations', params),
    ] as const,
  });
